var $one = function(obj, doc){
  if(doc){
    if(!/element/i.test(doc.toString())){
      doc = $one(doc);
    }
    return doc.querySelector(obj)
  }else{
    return document.querySelector(obj)
  }
}
var $$ = function(obj, doc){
  if(doc){
    if(!/element/i.test(doc.toString())){
      doc = $one(doc);
    }
    return doc.querySelectorAll(obj)
  }else{
    return document.querySelectorAll(obj)
  }
};

function getStyle (obj, attr) { 
  obj.currentStyle ? obj.currentStyle[attr] : getComputedStyle( obj )[attr]; 
}

NodeList.prototype.addEventListener = function(event, fn, useCapture) {
  this.forEach((element, index) => {
    const handler = function(originalEvent) {
      return fn.call(this, originalEvent, index, element)
    }
    
    element.addEventListener(event, handler, useCapture);
    
    if (!element._customListeners) element._customListeners = new Map();
    element._customListeners.set(fn, handler);
  });
  
  return this;
};
NodeList.prototype.show = function (displayType) {
  this.forEach(function(element) {
    element.style.display = displayType ? displayType : 'block';
  });
}
Element.prototype.show = function (displayType) {
  this.style.display = displayType ? displayType : 'block';
}
NodeList.prototype.hide = function () {
  this.forEach(function(element) {
    element.style.display = 'none';
  });
}
Element.prototype.hide = function () {
  this.style.display = 'none';
}

loadFunctionArr = window['loadFunctionArr'] || [];

document.addEventListener('DOMContentLoaded', function() {
    
  loadFunctionArr.forEach(function(fn){
    if(typeof fn == 'function'){
      fn();
    }
  });

  $$('[data-copy]').addEventListener('click', function(){
    var couponVal = this.getAttribute('data-copy');
    var text = this.getAttribute('data-text');
    copyText(couponVal.trim(), text);
    return false
  }); 

}, false);


function copyText(val, msg, okFn) {
  var inputObj = $$('#copyTextInput');
  if(inputObj.length){
    inputObj = inputObj[0];
    inputObj.value = val;
    inputObj.select();
    inputObj.setSelectionRange(0, inputObj.value.length),
        document.execCommand("Copy");
    inputObj.blur();
    var text = msg || "Copied Successfully";
    alert(text ).okBtn(function () {
        okFn && okFn();
    });
  }
}

/*
$$('[class*=template-product] .variant-picker__option-values input').forEach(function(v){
  v.addEventListener('change', function(){
    setTimeout(function(){
      var variants = window.ShopifyAnalytics.meta.product.variants;
      var selectedVariantId = +window.ShopifyAnalytics.meta.selectedVariantId;
      var sku = 0;
      for(var i = 0; i < variants.length; i++){
        if(variants[i].id == selectedVariantId){
          sku = variants[i].sku;
          break;
        }
      }
      setPreOrderHtml(sku);
    }, 10);
  })
});
*/

document.querySelector('[class*=template-product]')?.addEventListener('change', function(event) {
  const targetInput = event.target.closest('.variant-picker__option-values input[type="radio"], .variant-picker__option-values input[type="checkbox"]');
  if (targetInput) {
    setTimeout(() => {
      const { variants } = window.ShopifyAnalytics.meta.product;
      const selectedVariantId = JSON.parse(document.querySelector("script[data-variant]")?.textContent || "{}")?.sku;
      const selectedVariant = variants.find(v => v.sku === selectedVariantId);
      setPreOrderHtml(selectedVariant?.sku || -1);
    }, 10);
  }
});
function setPreOrderHtml(sku) {
  var label = document.querySelector('.pre-order-label');
  if(label){
    if(window['pre_order_product'] && pre_order_product.indexOf(sku) != -1){
      document.querySelector('.pre-order-label').innerHTML = '<span>Pre order</span>';
    }else{
      document.querySelector('.pre-order-label').innerHTML = '';
    }
  }
}

try {
  if($one('.pr-list-box') && $one('.pr-list-box').getAttribute('slide') == 1){
    var spaceBetween = parseInt(getComputedStyle($one('.pr-list')).gap);
    var swiper = new Swiper('.pr-list-box .swiper', {
      slidesPerView: 'auto',
      spaceBetween: spaceBetween,
      loop: true,
      autoplay: {
          delay: 3000,
          disableOnInteraction: true,
      },
      pagination: {
        el: '.pr-list-box .swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      navigation: {
          nextEl: ".pr-list-box .next-button",
          prevEl: ".pr-list-box .prev-button",
        },
    });
  }
} catch {

}